<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-dark">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">書籍詳細情報</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <!-- 読み込み中: spinner を表示 -->
        <div v-if="isLoading" class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="sr-only">読み込み中...</span>
          </div>
          <p class="mt-3">読み込み中...</p>
        </div>
        <!-- エラー: アラート表示 -->
        <div v-else-if="hasError">
          <base-alert type="warning">
            <span class="alert-inner--icon"><i class="fa fa-question"></i></span>
            <span class="alert-inner--text"><strong>書籍情報無し</strong> 書籍情報が見つかりませんでした。URLをお確かめいただくか、再読み込みして下さい。</span>
          </base-alert>
        </div>
        <!-- 成功: 書籍情報表示 -->
        <div v-else>
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3">{{ Book.Name }}</h2>
              <p v-show="Book.SubTitle != null">{{ Book.SubTitle }}</p>
            </div>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <p class="lead">{{ Book.Lead }}</p>
                <p v-html="Book.Description"></p>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src="Book.ImageUrl" class="img-fluid shadow">
            </div>
          </div>
          <hr>
          <div class="row row-grid align-items-center">
            <div class="col-md-6">
              <div v-if="Book.DisplayCPName != null">
                <h5>{{ Book.DisplayCPName }}（{{ Book.MainCharacter }}・{{ Book.PartnerCharacter }}）{{ Book.Type }}</h5>
              </div>
              <div v-else>
                <h5>{{ Book.MainCharacter }}中心{{ Book.Type }}</h5>
              </div>
              <div v-if="Book.OtherCharacters != null">
                <h6>　　その他主要人物：
                  <span v-for="(item, index) in Book.OtherCharacters" :key="item.id">
                  {{ item }}
                  <span v-if="index != Book.OtherCharacters.length - 1">,&nbsp;</span>
                </span>
                </h6>
              </div>
              <hr>
              <h5>{{ Book.PublishDate }}（{{ Book.EventName }}）初版第一刷発行</h5>
              <h5>{{ Book.Size }} {{ Book.Pages }}P　イベント頒布価格 {{ Book.Price }} 円</h5>
            </div>
            <div class="col-md-6">
              <div v-if="Book.OtherAuthors != null">
                <div v-if="Book.IsAnthology == true">
                  <h5 v-if="Book.OtherAuthors['表紙']">表紙：{{ Book.OtherAuthors['表紙'] }}</h5>
                  <h5>参加者：</h5>
                  <div v-for="item in Book.OtherAuthors['参加者']" :key="item.id">
                    <h5>　　{{ item }}</h5>
                  </div>
                </div>
                <div v-else>
                  <div v-for="(item, key, index) in Book.OtherAuthors" :key="index">
                    <h5>{{ key }}：{{ item }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row row-grid align-items-center">
            <div class="col-md-12">
              <div class="btn-wrapper">
                <div v-if="!Book.OnlineStoreName || Book.OnlineStoreName == 'BOOTH'">
                  <div v-if="Book.OnSaleWithPaper == true && Book.OnlineStore">
                    <a :href="Book.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-cart">
                        BOOTHで購入
                      </base-button>
                    </a>
                  </div>
                  <div v-else-if="Book.OnSaleWithPaper == true && !Book.OnlineStore">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="fa-regular fa-clock" disabled>
                      BOOTH準備中
                    </base-button>
                  </div>
                  <div v-else-if="Book.OnSaleWithDigital == true">
                    <a :href="Book.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-tablet-button">
                        BOOTHで購入(電子版)
                      </base-button>
                    </a>
                  </div>
                  <div v-else>
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="default" disabled
                                 icon="ni ni-fat-remove">
                      完売しました
                    </base-button>
                  </div>
                </div>
                <div v-if="Book.OnlineStoreName == 'Melonbooks'">
                  <div v-if="Book.OnSaleWithPaper == true && Book.OnlineStore">
                    <a :href="Book.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="success"
                                   icon="ni ni-cart">
                        メロンブックスで購入
                      </base-button>
                    </a>
                  </div>
                  <div v-else-if="Book.OnSaleWithPaper == true && !Book.OnlineStore">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="success"
                                 icon="fa-regular fa-clock" disabled>
                      メロンブックス準備中
                    </base-button>
                  </div>
                  <div v-else>
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="default" disabled
                                 icon="ni ni-fat-remove">
                      完売しました
                    </base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { useHead } from '@vueuse/head'
import { reactive, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "bookDetail",
  components: {
    moment
  },
  setup() {
    const route = useRoute()

    const headData = reactive({
      title: '書籍詳細情報',
      description: '',
      image: location.origin + '/img/brand/default.png',
      card_type: 'summary_large_image'
    })

    const Book = ref(null)
    const Events = reactive([])
    const isLoading = ref(true)
    const hasError = ref(false)

    // 初期化用の基本的な HEAD タグ
    useHead({
      title: {
        inner: '雛菊書房',
        separator: ' - ',
        complement: '書籍詳細情報'
      },
      meta: [
        { property: 'og:title', content: '雛菊書房 - 書籍詳細情報' },
        { property: 'og:type', content: 'article' },
        { property: 'og:description', content: '' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary_large_image' },
      ]
    })

    // タイトルとOGP情報をDOM に直接設定
    const updateHeadDetails = () => {
      const title = headData.title
      const description = headData.description
      const image = headData.image
      const cardType = headData.card_type

      // ページタイトルを直接設定
      document.title = `雛菊書房 - ${title}`

      // og:title を更新
      let ogTitle = document.querySelector('meta[property="og:title"]')
      if (ogTitle) {
        ogTitle.setAttribute('content', `雛菊書房 - ${title}`)
      }

      // og:description を更新
      let ogDesc = document.querySelector('meta[property="og:description"]')
      if (ogDesc) {
        ogDesc.setAttribute('content', description)
      }

      // og:image を更新
      let ogImage = document.querySelector('meta[property="og:image"]')
      if (ogImage) {
        ogImage.setAttribute('content', image)
      }

      // twitter:card を更新
      let twitterCard = document.querySelector('meta[property="twitter:card"]')
      if (twitterCard) {
        twitterCard.setAttribute('content', cardType)
      }
    }

    const getBook = async (BookId) => {
      isLoading.value = true
      hasError.value = false
      try {
        const response = await axios.get('/strapi/api/book-informations?populate=%2A&filters[BookId][$eq]=' + BookId)
        if(response.data.data.length != 0){
          const bookData = response.data.data[0]
          // EventId がある場合は、非同期で完了するまで待つ
          if(bookData['EventId'] !== null){
            try {
              const response2 = await axios.get('/strapi/api/event-informations?populate=%2A&filters[EventId][$eq]=' + bookData['EventId'])
              if(response2.data.data != null && response2.data.data.length != 0){
                bookData['EventName'] = response2.data.data[0]['Name']
                bookData['EventInfo'] = response2.data.data[0]
              }
            } catch(error) {
              console.log(error)
            }
          }
          switch (bookData['Size']){
            case 'Duodecimo':
              bookData['Size'] = "四六判";
              break;
            case 'Paperback':
              bookData['Size'] = "文庫";
              break;
            case 'Others':
              bookData['Size'] = "その他";
              break;
            default:
              break;
          }
          switch (bookData['Type']){
            case 'Normal':
              bookData['Type'] = "小説本";
              break;
            case 'Short':
              bookData['Type'] = "短編小説本";
              break;
            case 'ShortStories':
              bookData['Type'] = "短編集";
              break;
            case 'Series':
              bookData['Type'] = "小説本(シリーズ)";
              break;
            case 'LongStory':
              bookData['Type'] = "中長編小説本";
              break;
            case 'StoryAnthology':
              bookData['Type'] = "小説合同誌・アンソロジー";
              break;
            case 'StoryComicsAnthology':
              bookData['Type'] = "小説漫画合同誌・アンソロジー";
              break;
            case 'AllTypeAnthology':
              bookData['Type'] = "合同誌・アンソロジー";
              break;
            case 'Others':
              bookData['Type'] = bookData['OtherType'];
              break;
            default:
              break;
          }
          bookData['PublishDate'] = moment(bookData['PublishDate']).format('YYYY/MM/DD')
          if (bookData['Description'] !== null){
            bookData['Description'] = bookData['Description'].replace(/\r?\n/g, '<br >');
          }
          if (response.data.data[0].Image != null){
            bookData['ImageUrl'] = '/strapi' + response.data.data[0].Image.url
            headData.title =  response.data.data[0].Name
            headData.description = response.data.data[0].Lead
            headData.image = location.origin + '/strapi' + response.data.data[0].Image.formats.thumbnail.url
          } else {
            bookData['ImageUrl'] = null
            headData.title =  response.data.data[0].Name
            headData.description = response.data.data[0].Lead
            headData.card_type = 'summary'
          }
          Book.value = bookData
          // API完了後にタイトルとOGP情報を明示的に更新
          updateHeadDetails()
          isLoading.value = false
        } else {
          Book.value = null
          hasError.value = true
          isLoading.value = false
          headData.card_type = 'summary'
        }
      } catch(error) {
        console.log(error)
        hasError.value = true
        isLoading.value = false
      }
    }

    onMounted(async () => {
      moment.locale('ja')
      isLoading.value = true
      getBook(route.params.id)
    })

    return { Book, Events, headData, isLoading, hasError }
  }
};
</script>
<style>
</style>
